import { createContext } from 'react';

export const LocalizationContext = createContext<{
  localization: string;
  setLocalization: (localization: string) => void;
}>({
  localization: 'es-DO',
  setLocalization: (localization) => {},
});
